const SIMULATED_DELAY_MS = 180;

const VEHICLE_CATALOG = [
  {
    code: "VW",
    name: "Volkswagen",
    country: "Deutschland",
    models: [
      {
        code: "GOLF-VII",
        name: "Golf VII",
        years: "2012–2020",
        description: "MQB (AU, 5G1, BQ1)",
        variants: [
          {
            code: "GOLF-VII-HATCH",
            name: "Schrägheck (AU, 5G1)",
            body: "Schrägheck",
            years: "2012–2017",
            engines: [
              {
                code: "CLHA",
                name: "1.6 TDI 77 kW (105 PS)",
                fuel: "Diesel",
                displacement: 1598,
                powerKw: 77,
                powerPs: 105,
                ktype: "73316",
                vehicleKey: "VW-GOLF-VII-CLHA",
              },
              {
                code: "CJZA",
                name: "1.4 TSI 90 kW (122 PS)",
                fuel: "Benzin",
                displacement: 1395,
                powerKw: 90,
                powerPs: 122,
                ktype: "73310",
                vehicleKey: "VW-GOLF-VII-CJZA",
              },
            ],
          },
          {
            code: "GOLF-VII-VARIANT",
            name: "Variant (BA5, BV5)",
            body: "Kombi",
            years: "2013–2020",
            engines: [
              {
                code: "CRLB",
                name: "2.0 TDI 110 kW (150 PS)",
                fuel: "Diesel",
                displacement: 1968,
                powerKw: 110,
                powerPs: 150,
                ktype: "75582",
                vehicleKey: "VW-GOLF-VII-VARIANT-CRLB",
              },
            ],
          },
        ],
      },
      {
        code: "PASSAT-B8",
        name: "Passat B8",
        years: "2014–2023",
        description: "B8 (3G2, CB2)",
        variants: [
          {
            code: "PASSAT-B8-LIMO",
            name: "Limousine (3G2)",
            body: "Limousine",
            years: "2014–2023",
            engines: [
              {
                code: "DFGA",
                name: "2.0 TDI 140 kW (190 PS)",
                fuel: "Diesel",
                displacement: 1968,
                powerKw: 140,
                powerPs: 190,
                ktype: "80011",
                vehicleKey: "VW-PASSAT-B8-DFGA",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    code: "AUDI",
    name: "Audi",
    country: "Deutschland",
    models: [
      {
        code: "AUDI-A4-B9",
        name: "A4 B9",
        years: "2015–2023",
        description: "B9 (8W2, 8W5)",
        variants: [
          {
            code: "AUDI-A4-B9-AVANT",
            name: "Avant (8W5)",
            body: "Kombi",
            years: "2015–2023",
            engines: [
              {
                code: "DETA",
                name: "2.0 TDI 140 kW (190 PS)",
                fuel: "Diesel",
                displacement: 1968,
                powerKw: 140,
                powerPs: 190,
                ktype: "80880",
                vehicleKey: "AUDI-A4-B9-DETA",
              },
              {
                code: "DNWE",
                name: "2.0 TFSI 185 kW (252 PS)",
                fuel: "Benzin",
                displacement: 1984,
                powerKw: 185,
                powerPs: 252,
                ktype: "81242",
                vehicleKey: "AUDI-A4-B9-DNWE",
              },
            ],
          },
          {
            code: "AUDI-A4-B9-LIMO",
            name: "Limousine (8W2)",
            body: "Limousine",
            years: "2015–2023",
            engines: [
              {
                code: "CNHA",
                name: "2.0 TDI 110 kW (150 PS)",
                fuel: "Diesel",
                displacement: 1968,
                powerKw: 110,
                powerPs: 150,
                ktype: "80872",
                vehicleKey: "AUDI-A4-B9-CNHA",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    code: "OPEL",
    name: "Opel",
    country: "Deutschland",
    models: [
      {
        code: "OPEL-ASTRA-K",
        name: "Astra K",
        years: "2015–2021",
        description: "Astra K (B16)",
        variants: [
          {
            code: "OPEL-ASTRA-K-HATCH",
            name: "Schrägheck (B16)",
            body: "Schrägheck",
            years: "2015–2021",
            engines: [
              {
                code: "B16SHT",
                name: "1.6 CDTI 100 kW (136 PS)",
                fuel: "Diesel",
                displacement: 1598,
                powerKw: 100,
                powerPs: 136,
                ktype: "77978",
                vehicleKey: "OPEL-ASTRA-K-B16SHT",
              },
              {
                code: "B14XFL",
                name: "1.4 Turbo 110 kW (150 PS)",
                fuel: "Benzin",
                displacement: 1399,
                powerKw: 110,
                powerPs: 150,
                ktype: "77475",
                vehicleKey: "OPEL-ASTRA-K-B14XFL",
              },
            ],
          },
        ],
      },
    ],
  },
];

function delay(value) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(value), SIMULATED_DELAY_MS);
  });
}

function findMake(makeCode) {
  return VEHICLE_CATALOG.find((item) => item.code === makeCode);
}

function findModel(make, modelCode) {
  return make?.models.find((model) => model.code === modelCode);
}

function findVariant(model, variantCode) {
  return model?.variants.find((variant) => variant.code === variantCode);
}

export async function fetchVehicleMakes() {
  const result = VEHICLE_CATALOG.map((make) => ({
    code: make.code,
    name: make.name,
    country: make.country,
  }));
  return delay(result);
}

export async function fetchVehicleModels(makeCode) {
  const make = findMake(makeCode);
  const models = (make?.models ?? []).map((model) => ({
    code: model.code,
    name: model.name,
    years: model.years,
    description: model.description,
  }));
  return delay(models);
}

export async function fetchVehicleVariants(makeCode, modelCode) {
  const make = findMake(makeCode);
  const model = findModel(make, modelCode);
  const variants = (model?.variants ?? []).map((variant) => ({
    code: variant.code,
    name: variant.name,
    body: variant.body,
    years: variant.years,
  }));
  return delay(variants);
}

export async function fetchVehicleEngines(makeCode, modelCode, variantCode) {
  const make = findMake(makeCode);
  const model = findModel(make, modelCode);
  const variant = findVariant(model, variantCode);
  const engines = (variant?.engines ?? []).map((engine) => ({
    code: engine.code,
    name: engine.name,
    fuel: engine.fuel,
    displacement: engine.displacement,
    powerKw: engine.powerKw,
    powerPs: engine.powerPs,
    ktype: engine.ktype,
    vehicleKey: engine.vehicleKey,
  }));
  return delay(engines);
}
